import styled, { css } from 'styled-components';

import { ButtonStyle, ActionButtonStyle } from '../Button';

const ButtonLinkStyle = css`
  text-decoration: none;
`;

export const ActionButtonLink = (Linkvariabile) => (styled(Linkvariabile)`
  ${ActionButtonStyle};
  ${ButtonLinkStyle};
`);

export const ButtonLink = (Linkvariabile) => (styled(Linkvariabile)`
  ${ButtonStyle};
  ${ButtonLinkStyle};
`);
